export default __webpack_public_path__ + "static/media/bubble.25f0bb62.mp3";